import { Spinner } from "@shared/components";
import useBooleanState from "@shared/hooks/useBooleanState";
import { useUser } from "@shared/hooks/user";
import { root } from "@shared/utils";
import cn from "classnames";
import React, { memo } from "react";
import Modal from "react-modal";
import { useDispatch } from "react-redux";

import { toggleBuyInternetTimeModal } from "../../actions/actions";
import { useIsSweepstakesEnabled } from "../../hooks/use-is-sweepstakes-enabled";
import { useRequestBuyTime } from "../../hooks/use-request-buy-time";
import { useModalBuyInternetTimeModal } from "../../selectors/selectors";

import { Button } from "./Button";
import ButtonContainer from "./ButtonContainer";
import s from "./style.module.css";

export const BuyInternetTimeModal: React.FC = memo(() => {
  const dispatch = useDispatch();
  const isSweepstakesEnabled = useIsSweepstakesEnabled();
  const isResponseInternetTimeModalShown = useModalBuyInternetTimeModal();
  const { handleBuyTime } = useRequestBuyTime();
  const { value: loading, setFalse, setTrue } = useBooleanState(false);

  const { currency, balanceWin: totalWin } = useUser() ?? {};
  const onCloseModal = () => {
    dispatch(toggleBuyInternetTimeModal(false));
  };

  const handleButton = async (
    event: React.SyntheticEvent<HTMLDivElement>,
    amount: number
  ) => {
    const amountCurrency = amount * 100;
    setTrue();
    await handleBuyTime(event, amountCurrency);
    setFalse();
  };

  if (!isSweepstakesEnabled) {
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ModalComponent = Modal as any;

  return (
    <ModalComponent
      isOpen={isResponseInternetTimeModalShown}
      contentLabel="BuyInternetTime Modal"
      overlayClassName={s.buyInternetTimeOverlay}
      className={s.buyInternetTimeContent}
      appElement={root as HTMLElement}
      onRequestClose={onCloseModal}
    >
      {loading ? (
        <div className={s.loader}>
          <Spinner />
        </div>
      ) : (
        <>
          <div className={cn("modal-title", s.buyInternetTimeHeader)}>
            PURCHASE INTERNET TIME
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <ButtonContainer handleBuyTime={handleButton} />
          )}
          <div className={s.buyInternetTimeWrapperButtonMobile}>
            <Button
              value={0}
              title="BUY ALL"
              handleClick={handleButton}
              disabled={totalWin === 0}
            />
            <div className={s.buyInternetTimeValueTitle}>
              10 minutes = 1.00 {currency}
            </div>
            <div
              onClick={onCloseModal}
              className={cn(
                s.buyInternetTimeButtonValue,
                s.buyInternetTimeButtonValue_close
              )}
            >
              CLOSE
            </div>
          </div>
        </>
      )}
    </ModalComponent>
  );
});

BuyInternetTimeModal.displayName = "BuyInternetTimeModal";
